import React from 'react';
import { Flame, Clock, Tag, Lock, RotateCcw, Zap } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function OfferSection() {
  const {
    hh,
    mm,
    ss
  } = useCountdown();
  return <section id="oferta" className="py-14 md:py-20 bg-[radial-gradient(ellipse_at_center,#1a0e00_0%,#0a0a0a_70%)]" data-id="element-235">
      <div className="container" data-id="element-236">
        <div className="text-center mb-8 md:mb-10" data-id="element-237">
          <div className="section-label justify-center" data-id="element-238">Tu inversión hoy</div>
          <h2 className="font-playfair text-[clamp(1.7rem,3.5vw,2.7rem)] font-bold leading-[1.2] text-blanco text-center" data-id="element-239">
            Todo lo que recibes por
            <br data-id="element-240" />
            <em className="text-dorado-claro not-italic italic" data-id="element-241">
              un precio excepcional
            </em>
          </h2>
        </div>

        <div className="bg-[linear-gradient(90deg,#1a0800,#0d0600)] border border-[rgba(192,57,43,.3)] rounded-lg p-[18px_24px] flex items-center gap-4 mb-6 flex-wrap max-w-[860px] mx-auto max-sm:flex-col max-sm:items-start max-sm:gap-2.5" data-id="element-242">
          <Flame className="w-[1.3rem] h-[1.3rem] text-rojo-vivo shrink-0" data-id="element-243" />
          <div className="flex-1" data-id="element-244">
            <strong className="block text-blanco text-[.92rem] mb-[3px]" data-id="element-245">
              ¡Alta demanda! Solo quedan plazas disponibles a este precio
            </strong>
            <span className="text-[.78rem] text-gris-texto" data-id="element-246">
              El precio sube automáticamente cuando se agoten los cupos de este
              lanzamiento
            </span>
            <div className="w-full mt-2.5" data-id="element-247">
              <div className="bg-[rgba(255,255,255,.08)] rounded-full h-1.5 overflow-hidden" data-id="element-248">
                <div className="h-full bg-[linear-gradient(90deg,var(--rojo-vivo),var(--dorado))] rounded-full w-[78%]" data-id="element-249" />
              </div>
              <div className="text-[10px] text-rojo-vivo mt-1 font-semibold tracking-[.05em]" data-id="element-250">
                78% de los cupos ya tomados
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6 items-stretch max-md:grid-cols-1" data-id="element-251">
          <div className="bg-negro-suave border border-[rgba(201,151,43,.2)] rounded-lg p-[30px]" data-id="element-252">
            <img src="https://i.postimg.cc/DZR7b1vX/Copia-de-Sin-t-tulo-1.png" alt="Contenido" className="w-full rounded-md mb-[18px]" data-id="element-253" />
            <h3 className="font-playfair text-[1.15rem] text-dorado-claro mb-[18px] pb-[14px] border-b border-[rgba(201,151,43,.2)]" data-id="element-254">
              Resumen de tu paquete completo
            </h3>
            <div className="flex justify-between items-start py-3 border-b border-[rgba(255,255,255,.05)] text-[.87rem]" data-id="element-255">
              <span className="text-crema-oscuro flex-1" data-id="element-256">
                📘 Ebook Código Oscuro — 12 capítulos
              </span>
              <span className="text-rojo-vivo line-through text-[.82rem] ml-2.5 font-semibold" data-id="element-257">
                $28.99
              </span>
            </div>
            <div className="flex justify-between items-start py-3 border-b border-[rgba(255,255,255,.05)] text-[.87rem]" data-id="element-258">
              <span className="text-crema-oscuro flex-1" data-id="element-259">
                🛡️ Bono #1: Sistema Anti-Manipuladores
              </span>
              <span className="text-rojo-vivo line-through text-[.82rem] ml-2.5 font-semibold" data-id="element-260">
                $8.99
              </span>
            </div>
            <div className="flex justify-between items-start py-3 border-b border-[rgba(255,255,255,.05)] text-[.87rem]" data-id="element-261">
              <span className="text-crema-oscuro flex-1" data-id="element-262">
                🗣️ Bono #2: 7 Frases de Persuasión Rápida
              </span>
              <span className="text-rojo-vivo line-through text-[.82rem] ml-2.5 font-semibold" data-id="element-263">
                $7.99
              </span>
            </div>
            <div className="flex justify-between items-start py-3 text-[.87rem]" data-id="element-264">
              <span className="text-crema-oscuro flex-1" data-id="element-265">
                👥 Bono #3: Comunidad Exclusiva
              </span>
              <span className="text-rojo-vivo line-through text-[.82rem] ml-2.5 font-semibold" data-id="element-266">
                $11.03
              </span>
            </div>
          </div>

          <div className="bg-[linear-gradient(160deg,#1a0e00,#0c0800)] border-2 border-dorado rounded-lg p-[32px_28px] text-center flex flex-col justify-center relative overflow-hidden max-sm:p-[24px_16px]" data-id="element-267">
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-[linear-gradient(90deg,var(--rojo),var(--dorado),var(--dorado-claro))]" data-id="element-268" />
            <div className="absolute top-[18px] right-[18px] bg-rojo-vivo text-blanco text-[10px] font-bold tracking-[.1em] uppercase py-1 px-3 rounded-sm" data-id="element-269">
              Oferta
            </div>

            <div className="bg-[rgba(139,26,26,.15)] border border-[rgba(192,57,43,.3)] rounded-md p-[12px_16px] mb-5" data-id="element-270">
              <div className="text-[10px] uppercase tracking-[.1em] text-rojo-vivo mb-2 font-bold flex items-center justify-center gap-2" data-id="element-271">
                <Clock className="w-3.5 h-3.5" data-id="element-272" /> Este precio expira en:
              </div>
              <div className="flex gap-1.5 items-center justify-center" data-id="element-273">
                <div className="text-center" data-id="element-274">
                  <span className="font-playfair text-[1.8rem] font-black text-dorado-claro block leading-none" data-id="element-275">
                    {hh}
                  </span>
                  <div className="text-[8px] tracking-[.1em] uppercase text-gris-texto" data-id="element-276">
                    Horas
                  </div>
                </div>
                <span className="text-[1.5rem] text-dorado font-black leading-none pt-1" data-id="element-277">
                  :
                </span>
                <div className="text-center" data-id="element-278">
                  <span className="font-playfair text-[1.8rem] font-black text-dorado-claro block leading-none" data-id="element-279">
                    {mm}
                  </span>
                  <div className="text-[8px] tracking-[.1em] uppercase text-gris-texto" data-id="element-280">
                    Min
                  </div>
                </div>
                <span className="text-[1.5rem] text-dorado font-black leading-none pt-1" data-id="element-281">
                  :
                </span>
                <div className="text-center" data-id="element-282">
                  <span className="font-playfair text-[1.8rem] font-black text-dorado-claro block leading-none" data-id="element-283">
                    {ss}
                  </span>
                  <div className="text-[8px] tracking-[.1em] uppercase text-gris-texto" data-id="element-284">
                    Seg
                  </div>
                </div>
              </div>
            </div>

            <div className="text-[.82rem] text-gris-texto uppercase tracking-[.1em] mb-1" data-id="element-285">
              Valor total del paquete
            </div>
            <div className="font-playfair text-[1.7rem] text-rojo-vivo line-through mb-4" data-id="element-286">
              $57 USD
            </div>
            <div className="text-[.78rem] tracking-[.15em] uppercase text-dorado mb-1" data-id="element-287">
              Hoy solo pagas
            </div>
            <div className="font-playfair text-[4.2rem] font-black text-dorado-claro leading-none mb-1.5 max-sm:text-[3.2rem]" data-id="element-288">
              <sub className="text-[1.6rem] align-super" data-id="element-289">$</sub>6
              <span className="text-[2.2rem]" data-id="element-290">.36</span>
            </div>
            <div className="text-[.78rem] text-gris-texto mb-5" data-id="element-291">
              USD · Pago único · Acceso de por vida
            </div>

            <div className="inline-flex items-center justify-center bg-[rgba(29,185,84,.18)] border-2 border-verde text-[#2ecc71] text-[13px] font-bold py-[9px] px-[22px] rounded-full mb-[22px] tracking-[.02em] mx-auto" data-id="element-292">
              <Tag className="w-3.5 h-3.5 mr-1.5" data-id="element-293" />
              ¡Ahorras $50.64 — 89% OFF!
            </div>

            <a href="https://rutinaspracticas.com/cart/52921322438978:1" onClick={trackAddToCart} className="btn-compra animate-shimmer-fast inline-flex items-center justify-center" data-id="element-294">
              QUIERO ACCEDER AHORA
            </a>

            <div className="flex flex-wrap justify-center gap-3.5 text-xs text-gris-texto mt-1" data-id="element-295">
              <span className="flex items-center gap-1.5" data-id="element-296">
                <Lock className="w-3.5 h-3.5 text-dorado" data-id="element-297" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-298">
                <RotateCcw className="w-3.5 h-3.5 text-dorado" data-id="element-299" /> Garantía 7
                días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-300">
                <Zap className="w-3.5 h-3.5 text-dorado" data-id="element-301" /> Acceso inmediato
              </span>
            </div>

            <div className="flex items-center justify-center gap-2.5 mt-3.5 flex-wrap" data-id="element-302">
              <span className="text-[10px] text-gris-texto tracking-[.08em] uppercase" data-id="element-303">
                Aceptamos:
              </span>
              <div className="bg-[#1c1c1c] border border-[rgba(255,255,255,.1)] rounded px-2.5 py-1 text-[10px] font-bold text-[rgba(255,255,255,.5)] tracking-[.05em] flex items-center gap-1 text-[#1a73e8]" data-id="element-304">
                Visa
              </div>
              <div className="bg-[#1c1c1c] border border-[rgba(255,255,255,.1)] rounded px-2.5 py-1 text-[10px] font-bold text-[rgba(255,255,255,.5)] tracking-[.05em] flex items-center gap-1 text-[#eb001b]" data-id="element-305">
                MC
              </div>
              <div className="bg-[#1c1c1c] border border-[rgba(255,255,255,.1)] rounded px-2.5 py-1 text-[10px] font-bold text-[rgba(255,255,255,.5)] tracking-[.05em] flex items-center gap-1 text-[#003087]" data-id="element-306">
                PayPal
              </div>
              <div className="bg-[#1c1c1c] border border-[rgba(255,255,255,.1)] rounded px-2.5 py-1 text-[10px] font-bold text-[rgba(255,255,255,.5)] tracking-[.05em] flex items-center gap-1 text-[#007bc1]" data-id="element-307">
                Amex
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}